import { render, staticRenderFns } from "./ImagesCarousel.vue?vue&type=template&id=6dcbe5e0&scoped=true"
import script from "./ImagesCarousel.vue?vue&type=script&lang=js"
export * from "./ImagesCarousel.vue?vue&type=script&lang=js"
import style0 from "./ImagesCarousel.vue?vue&type=style&index=0&id=6dcbe5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcbe5e0",
  null
  
)

export default component.exports